import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=67a1ef54&scoped=true&"
import script from "./highlight.vue?vue&type=script&lang=js&"
export * from "./highlight.vue?vue&type=script&lang=js&"
import style0 from "./highlight.vue?vue&type=style&index=0&id=67a1ef54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1ef54",
  null
  
)

export default component.exports